import { NavLink } from "react-router-dom";
import BusImage from "../assets/images/bus.png";

const Terminal = () => {
  const nigerialData = [
    {
      state: "Abia",
      location: "Ohafia",
      address: "345, Eni Njoku Road Ohafia.",
      phone: "08028419211",
    },
    {
      state: "Akwaibom",
      location: "Eket",
      address: "50, Liverpool Road, Eket.",
      phone: "",
    },
    {
      state: "",
      location: "Uyo",
      address: "Terminal 4 Item Park, Uyo.",
      phone: "08028462080",
    },
    {
      state: "Bauchi",
      location: "Bauchi",
      address: "5, Maiduguri Bye Pass, Bauchi.",
      phone: "08024000340",
    },
    {
      state: "Borno",
      location: "Maiduguri",
      address: "Kano Station Maiduguri.",
      phone: "08024000340",
    },
    {
      state: "Cross River",
      location: "Calabar",
      address: "Opposite U Esuene Stadium, Calabar.",
      phone: "08028427406",
    },
    {
      state: "",
      location: "Ikom",
      address: "1, Border Road Ikom.",
      phone: "08028433741",
    },
    {
      state: "",
      location: "Ohafia",
      address: "Opposite, Diamond Bank Igoli, Ogoja",
      phone: "08028443930",
    },
    {
      state: "Delta",
      location: "Asaba",
      address: "No 89 Dennis Osadebe Way Opposite Textile Mill, Asaba.",
      phone: "08180315567",
    },
    {
      state: "FCT / Abuja",
      location: "Utako",
      address: "Dan Suleiman Cresent, Off Okotie Eboh, St Utako District",
      phone: "08028408277",
    },
    {
      state: "",
      location: "Kubwa",
      address: "Gado Nasko Way, Opposite 2/2 Court, Kubwa",
      phone: "",
    },
    {
      state: "Kaduna",
      location: "Kaduna",
      address: "Mando Park, Mando Lagos Garage, By Airforce Base, Mando",
      phone: "08028419211",
    },
    {
      state: "kano",
      location: "kano",
      address: "Angwauku, Opposite Federal Govt College",
      phone: "08028415483",
    },
    {
      state: "Lagos",
      location: "Ajah 1",
      address: "Ikota Shopping Plaza Ajah",
      phone: "",
    },
    {
      state: "",
      location: "Ajah 2",
      address: "After Abraham Adesanya Round About, Lekki - Epe Express Way",
      phone: "",
    },
    {
      state: "",
      location: "Cele",
      address: "158, Atinuke Complex Okota Road Isolo",
      phone: "08028456127",
    },
    {
      state: "",
      location: "Ikotun",
      address:
        "22, Ikotun Egbe Road, Opposite Synagogue Church Of All Nations, Ikotun",
      phone: "08028445647",
    },
    {
      state: "",
      location: "Jibowu",
      address:
        "12, Ikorodu Road, By Immac Group, Chicken Republic Building, Jibowu",
      phone: "08028445647",
    },
    {
      state: "",
      location: "Maza-Maza",
      address: "Badagry Express Way By Festac Gate",
      phone: "08028445261",
    },
    {
      state: "",
      location: "Yaba",
      address:
        "345,Muritala Mohammed Way, Opposite The Presbytarian Church Beside Conoil, Yaba",
      phone: "08055555595, 08028460890",
    },
    {
      state: "Nasarawa",
      location: "Lafia",
      address: "18 Makurdi Road, Opp. Magoda Petrol Station, Lafia",
      phone: "08028447950",
    },
    {
      state: "Ogun",
      location: "Abeokuta",
      address: "Oando Filling Station Opposite Lipede Shopping Complex Kuto.",
      phone: "08028402699",
    },
    {
      state: "",
      location: "Abeokuta",
      address: "Car Wash Bus Stop Abiola Way, Olorunsogo, Abeokuta",
      phone: "",
    },
    {
      state: "Oyo",
      location: "Ibadan",
      address:
        "4, Town Planning Way, Mobile Bus Stop, Near Local Govt Secretariat Ring Road, Ibadan",
      phone: "08028435347",
    },
    {
      state: "",
      location: "Ibadan",
      address: "Sango Elewure Bus Stop Beside Wema Bank, Sango, Abeokut",
      phone: "",
    },
    {
      state: "Plateau",
      location: "Jos",
      address: "No 5, Zaria By Pass, Jos",
      phone: "08028440595",
    },
    {
      state: "Rivers",
      location: "Port Harcourt",
      address: "Opposite Water Line Building, Waterline Junction, Bye Pass",
      phone: "08028452731",
    },
    {
      state: "Sokoto",
      location: "Sokoto",
      address: "Lemi Petrol Station, Gida Denre Sokoto Western Bye Pass.",
      phone: "08028457694",
    },
  ];

  const ghanaData = [
    {
      state: "Accra",
      location: "Accra",
      address: "Opp Apollo Theatre, Ring Rd, Kwame Nkrumah Circle",
      phone: "+233274447838, +233542652055",
    },
  ];

  const beninData = [
    {
      state: "Cotonou",
      location: "Cotonou",
      address:
        "Plot 162, Gbenonko Akpakpa, by Catholic Church/ Dantokpa Bridge, Cotonou",
      phone: "+22966999241, +22997243053",
    },
  ];

  return (
    <div>
      <div className="container mx-auto pt-24 md:pt-36 pb-12 px-5 text-black">
        <div className="flex flex-col gap-3 mb-7 md:pl-10">
          <div className="flex items-center justify-between ">
            <div className="flex items-center text-4xl font-bold head gap-3 ">
              <span className=""> TERMINALS</span>
              <div className="h-2 w-4 bg-black"></div>
            </div>
            <NavLink
              to="/routes"
              className="bg-[#B9000A] text-white font-bold text-base p-2 md:px-4"
            >
              View Routes
            </NavLink>
          </div>
          <div className="text text-lg md:w-[55%]">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
        <img src={BusImage} alt="" className="mb-10" />
        <div className="border border-pry p-2 px-4 font-bold text-base text-pry w-fit">
          Nigeria Terminal's
        </div>
        <div className={`table-wrapper dark-head `}>
          <table className="long-table">
            <thead>
              <tr>
                <th>STATE</th>
                <th>LOCATION</th>
                <th>ADDRESS</th>
                <th>PHONE</th>
              </tr>
            </thead>
            <tbody>
              {nigerialData.map((item, index) => (
                <tr key={index}>
                  <td>{item.state}</td>
                  <td>{item.location}</td>
                  <td>{item.address}</td>
                  <td>{item.phone}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="border border-pry p-2 px-4 font-bold text-base text-pry w-fit">
          Ghana Terminal's
        </div>
        <div className={`table-wrapper dark-head" `}>
          <table className="long-table">
            <thead>
              <tr>
                <th>STATE</th>
                <th>LOCATION</th>
                <th>ADDRESS</th>
                <th>PHONE</th>
              </tr>
            </thead>
            <tbody>
              {ghanaData.map((item, index) => (
                <tr key={index}>
                  <td>{item.state}</td>
                  <td>{item.location}</td>
                  <td>{item.address}</td>
                  <td>{item.phone}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="border border-pry p-2 px-4 font-bold text-base text-pry w-fit">
          Republic of Benin Terminal's
        </div>
        <div className={`table-wrapper dark-head" `}>
          <table className="long-table">
            <thead>
              <tr>
                <th>STATE</th>
                <th>LOCATION</th>
                <th>ADDRESS</th>
                <th>PHONE</th>
              </tr>
            </thead>
            <tbody>
              {beninData.map((item, index) => (
                <tr key={index}>
                  <td>{item.state}</td>
                  <td>{item.location}</td>
                  <td>{item.address}</td>
                  <td>{item.phone}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Terminal;
